var $56682ed6737a3277$exports = {};
$56682ed6737a3277$exports = {
    "endTime": `Sluttid`,
    "startTime": `Starttid`,
    "time": `Tid`
};


export {$56682ed6737a3277$exports as default};
//# sourceMappingURL=nb-NO.mjs.map
